import colors from 'vuetify/lib/util/colors'

export const light = {
  primary: {
    base: colors.blue.darken2,
    darken1: colors.blue.darken2,
  },
  secondary: colors.blueGrey.lighten1,
  accent: colors.blue.accent2,
  error: colors.red.darken1,
  info: colors.blue.darken1,
  success: colors.green.darken1,
  warning: colors.orange.darken1,
  // All keys will generate theme styles,
  // Here we add a custom `tertiary` color
  tertiary: colors.pink.base
}

export const dark = {
  primary: {
    //base: colors.amber.darken4,
    base: colors.lightBlue.lighten1,
    darken1: colors.blue.darken2,
  },
  secondary: colors.lime.accent3  ,
  accent: colors.blueGrey.darken1,
  error: colors.red.darken1,
  info: colors.blue.darken1,
  success: colors.green.darken1,
  warning: colors.orange.darken1,
  // All keys will generate theme styles,
  // Here we add a custom `tertiary` color
  tertiary: colors.pink.base
}